import { ISSUES_LIST } from '../../../constants';

const initialState = {
  data: null,
  loading: true,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ISSUES_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case ISSUES_LIST.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case ISSUES_LIST.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
